import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { SpecFieldNames } from '../../specification/constants/specification-field-names.enum';
import { RetailSpecificationActions, RetailSpecificationActionTypes } from '../actions/retail-specifications.actions';
import { RecipeFormValues } from './../models/form-values';

export interface RetailSpecificationFormState {
  forms: RecipeFormValues[];
  invoiceLoaded: boolean;
  newOrderCreation?: boolean;
}

export const initialState: RetailSpecificationFormState = {
  forms: [],
  invoiceLoaded: false,
  newOrderCreation: false,
};

export let formCounter = -1;

/**
 * Adds an item to the recipe
 */
const makeRecipeItem = (values: { [key: string]: any }): RecipeFormValues => {
  const id = ++formCounter;
  return {
    id: id,
    values: { ...values },
  };
};

/**
 * Returns an item seq num for the given item
 * If it has anticipated invoice it will return it's already defined seq num
 * If normal created item, will enerate it
 * @param item
 * @param index
 */
const makeSeqNum = (item: RecipeFormValues, index: number): number => {
  if (item.values[SpecFieldNames.CONTRACT_ANTICIPATED_INVOICE]) {
    return item.values[SpecFieldNames.CONTRACT_ANTICIPATED_INVOICE].itemCode;
  } else {
    return 10 * (index + 1);
  }
};

export function specificationFormReducer(
  state = initialState,
  action: RetailSpecificationActions | OrderBuilderActions,
): RetailSpecificationFormState {
  switch (action.type) {
    case RESET_BUILDER:
    case RetailSpecificationActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case RetailSpecificationActionTypes.ADD_ITEM: {
      return {
        ...state,
        forms: [makeRecipeItem(action.payload), ...state.forms],
      };
    }
    case RetailSpecificationActionTypes.UPDATE_ITEM: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === action.payload.id) {
            const quantity = action.payload.values[SpecFieldNames.QUANTITY];
            return {
              ...action.payload,
              values: {
                ...action.payload.values,
                [SpecFieldNames.QUANTITY]: quantity && typeof quantity === 'number' && +quantity.toFixed(6),
              },
            };
          } else {
            return item;
          }
        }),
      };
    }
    case RetailSpecificationActionTypes.SET_ITEMS_SEQ_NUM: {
      return {
        ...state,
        forms: state.forms.map((item, index) => {
          return { ...item, values: { ...item.values, [SpecFieldNames.ITEM_SEQ_NUM]: makeSeqNum(item, index) } };
        }),
      };
    }
    case RetailSpecificationActionTypes.SET_ADDITIONAL_SERVICES: {
      return {
        ...state,
        forms: state.forms.map(item => {
          // If order is patched by validate it will set itemSeqNum to a string value
          if (item.values[SpecFieldNames.ITEM_SEQ_NUM] === Number(action.payload.itemSeqNum)) {
            return {
              ...item,
              values: { ...item.values, [SpecFieldNames.ADDITIONAL_SERVICES]: action.payload.services },
            };
          } else {
            return item;
          }
        }),
      };
    }
    case RetailSpecificationActionTypes.SET_INVOICE_LOADED: {
      return {
        ...state,
        invoiceLoaded: action.payload,
      };
    }
    case RetailSpecificationActionTypes.RESET_ITEMS_SEQ_NUM: {
      return {
        ...state,
        forms: state.forms.map((item, index) => {
          return { ...item, values: { ...item.values, [SpecFieldNames.ITEM_SEQ_NUM]: undefined } };
        }),
      };
    }
    case RetailSpecificationActionTypes.SET_NEW_ORDER_CREATION: {
      return {
        ...state,
        newOrderCreation: action.payload,
      };
    }
    case RetailSpecificationActionTypes.REMOVE_ITEM: {
      return {
        ...state,
        forms: state.forms.filter(i => i.id !== action.payload),
      };
    }
    default: {
      return state;
    }
  }
}
